<template>
  <div>
    <div>
      <p>사전교육 패키지</p><br/>
      Server Info(API URL - {{this.API_SERVER_URL}}) | ENV : {{this.NODE_ENV}} | REL : {{this.NODE_REL}} | Ver : {{this.PROJECT_VER}}
    </div>
    <div v-if="this.NODE_REL === 'pre-release'">
    </div>
    <div v-else-if="this.NODE_REL === 'release'">
    </div>
  </div>
</template>

<script>
    export default {
        name: "CodmosInfo"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CodmosInfo.vue